//@flow

type SblLogModel = {
	RuntimeID: string,
	PageUrl: string,
	QuotationCaseID: number,
	OrderID: number,
	UserProfileID: number,
	IsOuterScriptError: boolean,
	Message: string,
	RawRuntimeLog: TraceKitModel;
}

const traceKitToSblModelMapper = (tracekitModel) => {

	const sblModel: SblLogModel = {
		RuntimeID: tracekitModel._special_.id,
		PageUrl: tracekitModel['TraceKit.Generic.Page']['location.href'],
		IsOuterScriptError: tracekitModel._special_.isOuterScriptError,
		Message: `${tracekitModel['error.name']}. ${tracekitModel['error.message']}`,
		...tracekitModel.SblModelData,
		RawRuntimeLog: tracekitModel,
	};

	return sblModel;
};

export { traceKitToSblModelMapper };
